<p class="dsd-mb-0">
  {{ 'preautorisation-en-ligne.boite-annulation.situation-change' | translate }}
  <a href="#" role="button" class="modal-link" (click)="showModal(); $event.preventDefault()" data-cy="link_annuler">
    {{ 'preautorisation-en-ligne.boite-annulation.lien-annuler' | translate }}
  </a>
</p>
